var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66406 9.33203L13.5506 16.9526C14.4322 17.5697 14.873 17.8783 15.3524 17.9978C15.7759 18.1033 16.2189 18.1033 16.6424 17.9978C17.1218 17.8783 17.5626 17.5697 18.4442 16.9526L29.3307 9.33203M9.06406 26.6654H22.9307C25.1709 26.6654 26.291 26.6654 27.1467 26.2294C27.8993 25.8459 28.5113 25.234 28.8948 24.4813C29.3307 23.6257 29.3307 22.5056 29.3307 20.2654V11.732C29.3307 9.49182 29.3307 8.37172 28.8948 7.51607C28.5113 6.76342 27.8993 6.1515 27.1467 5.76801C26.291 5.33203 25.1709 5.33203 22.9307 5.33203H9.06406C6.82385 5.33203 5.70375 5.33203 4.8481 5.76801C4.09545 6.1515 3.48353 6.76342 3.10004 7.51607C2.66406 8.37172 2.66406 9.49182 2.66406 11.732V20.2654C2.66406 22.5056 2.66406 23.6257 3.10004 24.4813C3.48353 25.234 4.09545 25.8459 4.8481 26.2294C5.70375 26.6654 6.82385 26.6654 9.06406 26.6654Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon01);
export default __webpack_public_path__ + "static/media/mail-icon-01.1b6de5f2996d671b8e008817cd480aa1.svg";
export { ForwardRef as ReactComponent };